import Settings from '../Components/Settings/Settings.vue';
import SettingsSlider from '../Components/Settings/SettingsSlider.vue';
import SettingsColorPicker from '../Components/Settings/SettingsColorPicker.vue';
import SettingsTextbox from '../Components/Settings/SettingsTextbox.vue';
import SettingsDropdown from '../Components/Settings/SettingsDropdown.vue';
import SettingsToggle from "../Components/Settings/SettingsToggle.vue";
import SettingsRadio from "../Components/Settings/SettingsRadio.vue";
import SettingsPosition from '../Components/Settings/SettingsPosition.vue';
import SettingsRotation from '../Components/Settings/SettingsRotation.vue';
import SettingsMediaPicker from '../Components/Settings/SettingsMediaPicker.vue';
import SettingsMediaCropper from "../Components/Settings/SettingsMediaCropper.vue";

const components = {
    Settings,
    SettingsSlider,
    SettingsColorPicker,
    SettingsTextbox,
    SettingsDropdown,
    SettingsToggle,
    SettingsRadio,
    SettingsPosition,
    SettingsRotation,
    SettingsMediaPicker,
    SettingsMediaCropper
};

const created = function(){
    const vm = this;
    const model = {};

    //Copy our metadata to our actual model
    Object.keys(vm.value).forEach(k => model[k] = vm.value[k]);

    //Make our property reactive
    vm.model = model;
};

const watch = {
    model: {
        handler(value){
            const vm = this;

            //Any model changes should be echoed upwards
            vm.$emit('input', value);
        },
        deep: true
    }
};

const data = () => ({
    model: {}
});

const props = {
    value: Object
};

export {
    components,
    created,
    watch,
    data,
    props
};

export default {
    components,
    created,
    watch,
    data,
    props
};